/**
 * @file コンポーネント：フル動画ページタイムライン機器 ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const TimelineItemDevice = (props) => {
    return <Presenter {...props} />;
};
